import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Rewrites relative Open Graph / Twitter / canonical URLs to absolute at
 * runtime, using the current origin. Updates on every SPA route change so
 * canonical + og:url reflect the current path.
 */
export default function HeadMeta() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    const origin = window.location.origin;
    const abs = (p) => (p?.startsWith("http") ? p : `${origin}${p?.startsWith("/") ? "" : "/"}${p || ""}`);

    document.querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]').forEach((el) => {
      const v = el.getAttribute("content");
      if (v) el.setAttribute("content", abs(v));
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", `${origin}${location.pathname}`);

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) { ogUrl = document.createElement("meta"); ogUrl.setAttribute("property", "og:url"); document.head.appendChild(ogUrl); }
    ogUrl.setAttribute("content", `${origin}${location.pathname}`);
  }, [location.pathname]);
  return null;
}
